import { Vector2 } from '@babylonjs/core';

export default interface IShape {
    position: Vector2;
    shape: Vector2;
    corner: Vector2;
    collide(other: IShape): boolean;
    inside(other: IShape): boolean;
    equal(other: IShape): boolean;
    smaller(other: IShape): boolean;
}

export class BaseShape implements IShape {

    public constructor(
        public position: Vector2,
        public shape: Vector2,
    ) { }

    public get corner(): Vector2 {
        const x = this.position.x - this.shape.x / 2;
        const y = this.position.y - this.shape.y / 2;
        return new Vector2(x, y);
    }

    /**
     * Procedura sprawdzająca czy elementy NACHODZĄ na siebie.
     * @param other Element z którym chcemy sprawdzić kolizje.
     */
    public collide(other: IShape): boolean {
        return (
            this.corner.x < other.corner.x + other.shape.x &&
            this.corner.x + this.shape.x > other.corner.x &&
            this.corner.y < other.corner.y + other.shape.y &&
            this.corner.y + this.shape.y > other.corner.y
        );
    }

    /**
     * Procedura sprawdzająca czy element znajduje się wewnątrz innego elementu.
     * @param other
     */
    public inside(other: IShape): boolean {
        return (
            this.corner.x >= other.corner.x &&
            this.corner.y >= other.corner.y &&
            this.corner.x + this.shape.x <= other.corner.x + other.shape.x &&
            this.corner.y + this.shape.y <= other.corner.y + other.shape.y
        );
    }

    /**
     * Procedura sprawdzająca czy elementy są tego samego kszatłtu.
     * @param other
     */
    public equal(other: IShape): boolean {
        return (
            this.shape.x === other.shape.x &&
            this.shape.y === other.shape.y
        );
    }

    /**
     * Procedura sprawdzająca czy element jest mniejszy od innego elementu;
     * @param other
     */
    public smaller(other: IShape): boolean {
        return (
            this.shape.x < other.shape.x ||
            this.shape.y < other.shape.y
        );
    }
}
